import React from 'react'
import EditActividadAdminPage from './EditActividadAdminPage'

const EditActividadAdminWrapper = () => {
  return <EditActividadAdminPage />
}

export default EditActividadAdminWrapper
